import { SearchQuery } from '~/features/advanced-search/types';
import { ClauseIdentificationResponse } from '~/features/automation/types';
import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';

interface Request {
  name: string;
}

interface Response {
  bulk_tagging_enabled_status: 'active' | 'suspended';
  bulk_tagging_last_identification: Nullable<string>;
  bulk_tagging_total_identifications: number;
  smart_clause_last_identification: Nullable<string>;
  smart_clause_total_identifications?: number;
  bulk_tagging_filters: SearchQuery;
}

export const getIdentifications = async ({
  name,
}: Request): Promise<ClauseIdentificationResponse> => {
  const response: Response = await pilot.get(
    '/ai-command-center/identification/',
    {
      params: { clause_name: name },
    },
  );

  return {
    bulkTaggingEnabledStatus: response.bulk_tagging_enabled_status,
    bulkTaggingLastIdentification: response.bulk_tagging_last_identification,
    bulkTaggingTotalIdentifications:
      response.bulk_tagging_total_identifications,
    smartClauseLastIdentification: response.smart_clause_last_identification,
    smartClauseTotalIdentifications:
      response.smart_clause_total_identifications ?? 0,
    filters: response.bulk_tagging_filters ? response.bulk_tagging_filters : [],
  };
};
